/* ConnectTelegram — the blocking first step for a User who owes a Telegram connection.
   Route: /connect-telegram. No close button: the only ways out are connecting or
   signing out. Once the bot confirms, the User continues into new-user onboarding. */
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { OnboardingStage } from '../Onboarding/OnboardingStage';
import { Panel, Title, Btn, Icon, C } from '../Onboarding/onboardingKit';
import { useTelegramConnect } from './useTelegramConnect';

export function ConnectTelegram() {
  const { t } = useTranslation('onboarding');
  const navigate = useNavigate();
  const { markTelegramConnected, logout } = useAuth();
  const { state, url, start } = useTelegramConnect(() => {
    markTelegramConnected();
    navigate('/', { replace: true });
  });

  const waiting = state === 'waiting' || state === 'opening';

  return (
    <OnboardingStage pose={waiting ? 'think' : 'explain'}>
      <Panel width={540}>
        <Title k={t('telegram.kicker')} h={t('telegram.title')} sub={t('telegram.sub')} />
        {state === 'waiting' ? (
          <div style={{ border: `1px solid ${C.line}`, borderRadius: 16, padding: 18, color: C.muted, fontSize: 14.5, lineHeight: 1.55 }}>
            {t('telegram.waiting')}
            {url && (
              <div style={{ marginTop: 10 }}>
                <a href={url} target="_blank" rel="noreferrer" style={{ color: C.purpleHi, fontWeight: 600 }}>{t('telegram.openAgain')}</a>
              </div>
            )}
          </div>
        ) : (
          <>
            {state === 'expired' && <p style={{ color: C.muted, fontSize: 14 }}>{t('telegram.expired')}</p>}
            {state === 'error' && <p style={{ color: '#e5484d', fontSize: 14 }}>{t('telegram.error')}</p>}
            <Btn wide onClick={() => { void start(); }} disabled={waiting} icon="arrow">
              <Icon name="chat" size={18} />{t('telegram.cta')}
            </Btn>
          </>
        )}
        <div style={{ marginTop: 18, textAlign: 'center' }}>
          <a onClick={() => { void logout(); }} style={{ color: C.faint, fontSize: 13.5, cursor: 'pointer' }}>{t('telegram.signOut')}</a>
        </div>
      </Panel>
    </OnboardingStage>
  );
}
